import { render, staticRenderFns } from "./EditDetailsPopoverItem.vue?vue&type=template&id=49762511&"
import script from "./EditDetailsPopoverItem.vue?vue&type=script&lang=js&"
export * from "./EditDetailsPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports